import { defineMessages } from 'react-intl';

export default defineMessages({
  description: { defaultMessage: 'You can stake {asset} for protocol revenue sharing.' },
  caption: { defaultMessage: 'How much would you like to stake?' },
  availableToStake: { defaultMessage: 'Available to stake' },
});
